<template>
  <svg :width="width" :height="height" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30.4029 0H4.59706C2.06221 0 0 2.06221 0 4.59706V30.4029C0 32.9378 2.06221 35 4.59706 35H30.4029C32.9378 35 35 32.9378 35 30.4029V4.59706C35 2.06221 32.9378 0 30.4029 0ZM32.6163 30.4029C32.6163 31.6234 31.6234 32.6163 30.4029 32.6163H4.59706C3.37663 32.6163 2.38366 31.6234 2.38366 30.4029V4.59706C2.38366 3.37663 3.37663 2.38366 4.59706 2.38366H30.4029C31.6234 2.38366 32.6163 3.37663 32.6163 4.59706V30.4029Z" :fill="color"/>
  <path d="M28.7933 6.20673C28.1283 5.54169 27.0505 5.54169 26.3855 6.20673L17.742 14.8502L9.09815 6.20673C8.43311 5.54169 7.35535 5.54169 6.69031 6.20673C6.02527 6.87177 6.02527 7.94953 6.69031 8.61457L15.3342 17.2584L6.69031 25.9019C6.02527 26.567 6.02527 27.6447 6.69031 28.3098C7.02266 28.6421 7.45853 28.8083 7.8944 28.8083C8.33027 28.8083 8.7658 28.6421 9.09849 28.3098L17.7423 19.6659L26.3862 28.3098C26.7185 28.6421 27.1544 28.8083 27.5903 28.8083C28.0261 28.8083 28.4617 28.6421 28.7944 28.3098C29.4594 27.6447 29.4594 26.567 28.7944 25.9019L20.1498 17.2581L28.7937 8.61423C29.4584 7.94953 29.4584 6.87143 28.7933 6.20673Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 35
    },
    height: {
      type: Number,
      default: 35
    },
    color: {
      type: String,
      default: 'var(--color-pri)'
    }
  }
}
</script>

<style>

</style>
